// The colour chips of a variety listing. A listing can hold the same varieties
// twice, as the A to Z grid and as the grouped view, with one of the two
// hidden. A colour is applied to every card in both, so the views agree when
// the shopper swaps them, but only the view that is showing is counted.
const COUNT_LINE = 'Showing [shown] of [total] varieties';

document.querySelectorAll('[data-variety-filter-root]').forEach((root) => {
  const colourGroup = root.querySelector('[data-filter-colour-group]');
  if (!colourGroup) return;

  const grids = Array.from(root.querySelectorAll('[data-variety-grid]'));
  const countEl = root.querySelector('[data-filter-count]');
  const emptyEl = root.querySelector('[data-filter-empty]');
  const countLine = (countEl && countEl.dataset.countLine) || COUNT_LINE;

  // A grid's view is the grouped container it sits in, or the grid itself.
  // assets/variety-view.js hides a view on the view, never on a group.
  const isShowing = (grid) => {
    const view = grid.closest('[data-variety-season]') || grid;
    return !view.hidden && view.style.display !== 'none';
  };

  let colour = '';

  function apply() {
    let shown = 0;
    let total = 0;

    grids.forEach((grid) => {
      const counted = isShowing(grid);
      let matches = 0;

      grid.querySelectorAll('.variety-card').forEach((card) => {
        const show = !colour || card.dataset.colour === colour;
        // style.display, not hidden: .variety-card is display:flex and [hidden] loses that fight.
        card.style.display = show ? '' : 'none';
        if (show) matches += 1;
        if (counted) total += 1;
      });

      // A group left with no card would be a heading over nothing.
      const group = grid.closest('[data-variety-group]');
      if (group) group.hidden = matches === 0;
      if (counted) shown += matches;
    });

    if (countEl) {
      countEl.hidden = false;
      countEl.textContent = countLine.replace('[shown]', String(shown)).replace('[total]', String(total));
    }
    if (emptyEl) emptyEl.hidden = shown !== 0;
  }

  colourGroup.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-filter-colour-pick]');
    if (!btn) return;
    colour = btn.dataset.filterColourPick || '';
    colourGroup.querySelectorAll('[data-filter-colour-pick]').forEach((b) => {
      b.setAttribute('aria-pressed', String(b === btn));
    });
    apply();
  });

  // The other view is now the one showing, so it is the one to count.
  root.addEventListener('variety:view', apply);

  apply();
});
